export default __webpack_public_path__ + "static/review-img-11e955354977cfdf7c536af80e6178f0.png";